
import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface GiantStarAnimationProps {
  isVisible: boolean;
  onAnimationComplete: () => void;
}

const GiantStarAnimation: React.FC<GiantStarAnimationProps> = ({ 
  isVisible, 
  onAnimationComplete 
}) => {
  const [animationClass, setAnimationClass] = useState('opacity-0 scale-0');
  
  useEffect(() => {
    if (isVisible) {
      // Start with a small star then grow
      setAnimationClass('opacity-100 scale-100');
      
      // Remove the star after animation completes
      const timer = setTimeout(() => {
        setAnimationClass('opacity-0 scale-0');
        setTimeout(() => {
          onAnimationComplete();
        }, 300);
      }, 1500); // Animation time for visibility
      
      return () => clearTimeout(timer);
    }
  }, [isVisible, onAnimationComplete]);
  
  if (!isVisible) return null;
  
  return (
    <div className="fixed inset-0 flex items-center justify-center pointer-events-none z-50">
      <div className={cn(
        "transition-all duration-1000 transform", 
        animationClass
      )}>
        <Star 
          size={320} // Increased size
          className="text-yellow-400 fill-yellow-400 animate-spin-slow" 
          strokeWidth={1}
        />
      </div>
    </div>
  );
};

export default GiantStarAnimation;
